export default "__VITE_ASSET__DWoPhgCZ__"